import { ProviderBuilder } from '@hub3js/core';
import { privyAdapter } from '../adapter';
import { SOCIAL_WALLET_TYPE } from './constants';
import { buildEvmNamespace } from './namespaces/evm';
import { buildSolanaNamespace } from './namespaces/solana';
import { getMetaData } from './utils';
export function buildProvider() {
    const evm = buildEvmNamespace();
    const solana = buildSolanaNamespace();
    const provider = new ProviderBuilder(SOCIAL_WALLET_TYPE)
        .init(function (context) {
        const [, setState] = context.state();
        setState('installed', true);
        privyAdapter.setIsProviderInitiated(true);
    })
        .config('metadata', getMetaData())
        .add('evm', evm)
        .add('solana', solana)
        .build();
    privyAdapter.setProvider(provider);
    return provider;
}
